module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/main-view@2x_e9b02c7e0e2b25712b292bfa0649227b.png";